import React from "react";
import { Box, useTheme } from "@mui/material";

/**
 * REV-2299 safety net: shown wherever an assistant message would otherwise
 * render as an empty bubble — e.g. a card component's JSON failed to parse,
 * or the frame carried no displayable content at all. Never fail silently:
 * show the raw payload (if any) so the failure is visible and debuggable
 * instead of looking like the message never arrived.
 */
interface ChatMessageUnavailableProps {
  raw?: unknown;
}

const ChatMessageUnavailable: React.FC<ChatMessageUnavailableProps> = ({
  raw,
}) => {
  const theme = useTheme();

  let pretty = "";
  if (raw !== undefined && raw !== null && raw !== "") {
    if (typeof raw === "string") {
      try {
        pretty = JSON.stringify(JSON.parse(raw), null, 2);
      } catch {
        pretty = raw;
      }
    } else {
      try {
        pretty = JSON.stringify(raw, null, 2);
      } catch {
        pretty = String(raw);
      }
    }
  }

  return (
    <Box sx={{ width: "100%" }}>
      {pretty ? (
        <Box
          component="pre"
          sx={{
            margin: 0,
            padding: theme.spacing(1.5),
            borderRadius: theme.spacing(1),
            backgroundColor: theme.palette.action.hover,
            fontSize: theme.typography.caption.fontSize,
            fontFamily: "monospace",
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            maxHeight: "20rem",
            overflow: "auto",
          }}
        >
          {pretty}
        </Box>
      ) : null}
    </Box>
  );
};

export default ChatMessageUnavailable;
